<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-container-sidebar items-no-padding" spacer v-model="sidebarActive">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>Nueva Firma Masiva</h4>
        <feather-icon icon="XIcon" @click.stop="closeSidebar" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <div class="p-6 scroll-area--data-list-add-new">
      <div class="mb-4">
        <vs-input 
          label="Nombre de la Firma Masiva" 
          v-model="containerName" 
          class="w-full" 
          placeholder="Ej. Documentos Enero 2025"
        />
      <div class="mb-5">
        <label class="text-sm opacity-75">Logo (Opcional)</label>
        <div 
          class="flex flex-col items-center justify-center border-2 border-dashed border-gray-400 rounded-lg p-4 mt-1 bg-gray-50 cursor-pointer hover:bg-white transition-colors" 
          @click="$refs.logoInput.click()"
        >
            <feather-icon icon="ImageIcon" svgClasses="w-8 h-8 text-grey mb-2" />
            <span v-if="!logoFile" class="text-xs text-grey text-center">Haz clic para seleccionar el logo</span>
            <span v-else class="text-xs text-primary font-medium text-center">{{ logoFile.name }}</span>
            <input 
              type="file" 
              ref="logoInput"
              @change="handleLogoUpload" 
              accept="image/*"
              class="hidden"
            />
        </div>
        <p class="text-xs text-gray-400 mt-2">Formatos: PNG, JPG. Tamaño máx: 2MB</p>
      </div>

      <vs-divider>Firmantes</vs-divider>
      
      <div class="mb-4">
        <vs-input 
          label="Nombre del Firmante" 
          v-model="signerName" 
          class="w-full mb-2" 
          placeholder="Nombre completo"
        />
        <vs-input 
          label="Email del Firmante" 
          v-model="signerEmail" 
          class="w-full" 
          placeholder="correo@ejemplo.com"
        />
        <vs-button class="mt-4 w-full" type="border" icon-pack="feather" icon="icon-plus" @click="addSigner" :disabled="!signerName || !signerEmail">Añadir Firmante</vs-button>
      </div>

      <div v-if="signers.length > 0" class="mb-4">
        <h6 class="mb-2">Firmantes añadidos:</h6>
        <div v-for="(signer, index) in signers" :key="index" class="flex items-center justify-between p-3 border rounded mb-2 bg-gray-50">
          <div>
            <p class="font-bold text-sm">{{ signer.name }}</p>
            <p class="text-xs text-grey">{{ signer.email }}</p>
          </div>
          <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 text-danger cursor-pointer" @click="removeSigner(index)" />
        </div>
      </div>

      <span v-if="error" class="text-danger text-sm">{{ error }}</span>
    </div>
</div>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6 shadow-md" @click="submitCreate" :disabled="!containerName || signers.length === 0">Crear Firma Masiva</vs-button>
      <vs-button type="border" color="danger" @click="closeSidebar">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'CreateContainer',
  props: {
    active: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      containerName: '',
      signerName: '',
      signerEmail: '',
      signers: [],
      logoFile: null,
      error: null
    }
  },
  computed: {
    sidebarActive: {
      get() {
        return this.active
      },
      set(val) {
        if (!val) {
          this.closeSidebar()
        }
      }
    }
  },
  methods: {
    ...mapActions({
      createContainerAction: 'containerManagement/createContainer'
    }),
    handleLogoUpload(e) {
      const files = e.target.files;
      if (files.length > 0) {
        this.logoFile = files[0];
      } else {
        this.logoFile = null;
      }
    },
    addSigner() {
      if (this.signerName && this.signerEmail) {
        this.signers.push({
          name: this.signerName,
          email: this.signerEmail
        });
        this.signerName = '';
        this.signerEmail = '';
        this.error = null;
      }
    },
    removeSigner(index) {
      this.signers.splice(index, 1);
    },
    submitCreate() {
      if (!this.containerName.trim()) {
        this.error = 'El nombre de la firma masiva es requerido.'
        return
      }
      if (this.signers.length === 0) {
         this.error = 'Debe añadir al menos un firmante.'
         return
      }
      this.error = null

      this.$vs.loading()
      
      const payload = {
        name: this.containerName,
        description: 'Firmado de contratos',
        tries: 3,
        remember_every: 2,
        remember_at: "09:30",
        sign_mode: "CLASSIC",
        sign_position: "NONE",
        mode_logo: "FULL_BRANDING",
        sign_ordered: "ACTIVE",
        notification_mode: "ENABLED",
        webhook: "https://webhook.site/a2980c77-1bf7-41d8-8d75-13949813f209",
        logo: this.logoFile,
        signatures: this.signers,
        spectators: []
      }
      
      console.log('CREATE CONTAINER SIDEBAR PAYLOAD:', payload)

      this.createContainerAction(payload)
        .then(() => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Éxito',
            text: 'Firma masiva creada correctamente.',
            color: 'success',
            position: 'top-center',
            time: 3000
          });
          this.$emit('create-success')
          this.closeSidebar()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error || 'Error al crear la firma masiva',
            color: 'danger',
            position: 'top-center',
            time: 3000
          });
        })
    },
    closeSidebar() {
      this.containerName = ''
      this.signerName = ''
      this.signerEmail = ''
      this.signers = []
      this.logoFile = null
      this.error = null
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-container-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
  }
}

.scroll-area--data-list-add-new {
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
  overflow-y: auto;
}

::v-deep .vs-sidebar--footer {
    border-top: 1px solid rgba(0,0,0,0.05);
}
</style>
